<template>
  <!-- Table Container Card -->
  <b-card
    no-body
  >
    <div class="ml-2 mr-2">
      <validation-observer ref="gatewayConfigRules">
        <b-form
          id="gateway-fee-configuration"
          @submit.prevent="handleSubmit"
        >
          <b-row>
            <b-col
              cols="12"
            >
              <h5 class="section-label mb-2 mt-2">
                {{ $t('Configure Gateway Credentials') }}
              </h5>
              <b-row class="match-height">
                <b-col md="6">
                  <SelectField
                    id="gateway-provider"
                    v-model="transactionFormData.gateway"
                    :label="$t('Gateway Provider')"
                    :options="gatewayProviderOptions"
                    :error-name="$t('Gateway Provider')"
                    rules="required"
                    item="label"
                    :reduce="option => option"
                    :placeholder="$t('Select')"
                    :readonly="isReadonly"
                  />
                </b-col>
              </b-row>

              <b-row
                v-if="isNIPSelected && getUserPermission('VIEW_TRANSFER_GATEWAY_CREDENTIAL')"
                class="match-height mt-1"
              >
                <b-col md="6">
                  <InputField
                    id="nip-client-id"
                    v-model="nipCredentialForm.clientID"
                    :label="$t('Client ID')"
                    :placeholder="$t('Enter Client ID')"
                    rules="required"
                    :error-name="$t('Client ID')"
                  />
                </b-col>
                <b-col md="6">
                  <InputField
                    id="nip-client-secret"
                    v-model="nipCredentialForm.clientSecret"
                    :label="$t('Client Secret')"
                    :placeholder="$t('Enter Client Secret')"
                    rules="required"
                    :error-name="$t('Client Secret')"
                  />
                </b-col>
                <b-col md="6">
                  <InputField
                    id="nip-api-key"
                    v-model="nipCredentialForm.apiKey"
                    :label="$t('API Key')"
                    :placeholder="$t('Enter API Key')"
                    rules="required"
                    :error-name="$t('API Key')"
                  />
                </b-col>
                <b-col md="6">
                  <InputField
                    id="nip-app-name"
                    v-model="nipCredentialForm.appName"
                    :label="$t('App Name')"
                    :placeholder="$t('Enter App Name')"
                    rules="required"
                    :error-name="$t('App Name')"
                  />
                </b-col>
                <b-col
                  cols="12"
                  class="d-flex align-items-center justify-content-lg-end mt-1 mb-2"
                >
                  <Button
                    v-if="getUserPermission('ADD_NIP_CREDENTIAL') && !hasNIPCredential"
                    :label="$t('Add NIP Credentials')"
                    :loading="isNIPAddLoading"
                    :disabled="isNIPAddLoading || isNIPUpdateLoading"
                    size="md"
                    class="mr-1"
                    @click="handleNIPCredentialSubmit"
                  />
                  <Button
                    v-if="getUserPermission('UPDATE_NIP_CREDENTIAL') && hasNIPCredential"
                    :label="$t('Update NIP Credentials')"
                    :loading="isNIPUpdateLoading"
                    :disabled="isNIPUpdateLoading || isNIPAddLoading"
                    size="md"
                    class="mt-1"
                    @click="handleNIPCredentialUpdate"
                  />
                </b-col>
              </b-row>

              <b-row
                v-if="isISWSelected && getUserPermission('VIEW_TRANSFER_GATEWAY_CREDENTIAL')"
                class="match-height mt-1"
              >
                <b-col md="6">
                  <InputField
                    id="isw-client-id"
                    v-model="iswCredentialForm.clientID"
                    :label="$t('Client ID')"
                    :placeholder="$t('Enter Client ID')"
                    rules="required"
                    :error-name="$t('Client ID')"
                  />
                </b-col>
                <b-col md="6">
                  <InputField
                    id="isw-client-secret"
                    v-model="iswCredentialForm.clientSecret"
                    :label="$t('Client Secret')"
                    :placeholder="$t('Enter Client Secret')"
                    rules="required"
                    :error-name="$t('Client Secret')"
                  />
                </b-col>
                <b-col
                  cols="12"
                  class="d-flex align-items-center justify-content-lg-end mt-1 mb-2"
                >
                  <Button
                    v-if="getUserPermission('ADD_ISW_CREDENTIAL') && !hasISWCredential"
                    :label="$t('Add ISW Credentials')"
                    :loading="isISWAddLoading"
                    :disabled="isISWAddLoading || isISWUpdateLoading"
                    size="md"
                    class="mr-1"
                    @click="handleISWCredentialSubmit"
                  />
                  <Button
                    v-if="getUserPermission('UPDATE_ISW_CREDENTIAL') && hasISWCredential"
                    :label="$t('Update ISW Credentials')"
                    :loading="isISWUpdateLoading"
                    :disabled="isISWUpdateLoading || isISWAddLoading"
                    size="md"
                    class="mt-1"
                    @click="handleISWCredentialUpdate"
                  />
                </b-col>
              </b-row>

              <b-row
                v-if="isProvidusSelected && getUserPermission('VIEW_TRANSFER_GATEWAY_CREDENTIAL')"
                class="match-height mt-1"
              >
                <b-col md="6">
                  <InputField
                    id="providus-username"
                    v-model="providusCredentialForm.userName"
                    :label="$t('User Name')"
                    :placeholder="$t('Enter User Name')"
                    rules="required"
                    :error-name="$t('User Name')"
                  />
                </b-col>
                <b-col md="6">
                  <!-- <InputField
                    id="providus-password"
                    v-model="providusCredentialForm.password"
                    :label="$t('Password')"
                    :placeholder="$t('Enter Password')"
                    rules="required"
                    :error-name="$t('Password')"
                  /> -->
                  <InputPasswordField
                    id="providus-password"
                    v-model="providusCredentialForm.password"
                    :label="$t('Password')"
                    :placeholder="$t('Enter Password')"
                    :error-name="$t('Password')"
                    rules="required"
                  />
                </b-col>
                <b-col
                  cols="12"
                  class="d-flex align-items-center justify-content-lg-end mt-1 mb-2"
                >
                  <Button
                    v-if="getUserPermission('ADD_PROVIDUS_CREDENTIAL') && !hasProvidusCredential"
                    :label="$t('Add Providus Credentials')"
                    :loading="isProvidusAddLoading"
                    :disabled="isProvidusAddLoading || isProvidusUpdateLoading"
                    size="md"
                    class="mr-1"
                    @click="handleProvidusCredentialSubmit"
                  />
                  <Button
                    v-if="getUserPermission('UPDATE_PROVIDUS_CREDENTIAL') && hasProvidusCredential"
                    :label="$t('Update Providus Credentials')"
                    :loading="isProvidusUpdateLoading"
                    :disabled="isProvidusUpdateLoading || isProvidusAddLoading"
                    size="md"
                    class="mt-1"
                    @click="handleProvidusCredentialUpdate"
                  />
                </b-col>
              </b-row>

            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
      <validation-observer ref="etzGatewayConfigRules">
        <b-form @submit.prevent="handleETZCredentialSubmit">
          <b-row
            v-if="isETZSelected && getUserPermission('VIEW_TRANSFER_GATEWAY_CREDENTIAL')"
            class="match-height mt-1"
          >
            <b-col md="6">
              <InputField
                id="etz-client-id"
                v-model="etzCredentialForm.clientID"
                :label="$t('NE/ FT Client ID')"
                :placeholder="$t('Enter NE/ FT Client ID')"
              />
            </b-col>
            <b-col md="6">
              <InputField
                id="etz-client-secret"
                v-model="etzCredentialForm.clientSecret"
                :label="$t('NE/FT Cypher')"
                :placeholder="$t('Enter NE/FT Cypher')"
              />
            </b-col>
            <b-col md="6">
              <InputField
                id="etz-pin"
                v-model="etzCredentialForm.pin"
                :label="$t('PIN')"
                :placeholder="$t('Enter PIN')"
              />
            </b-col>
            <b-col md="6">
              <InputField
                id="etz-pin-enc-key"
                v-model="etzCredentialForm.pinEncKey"
                :label="$t('NE/ FT Enc. Key')"
                :placeholder="$t('NE/ FT Enc. Key')"
              />
            </b-col>
            <b-col md="6">
              <InputField
                id="etz-salt"
                v-model="etzCredentialForm.salt"
                :label="$t('Salt')"
                :placeholder="$t('Enter Salt')"
              />
            </b-col>
            <b-col md="6">
              <InputField
                id="etz-emc-key"
                v-model="etzCredentialForm.encKey"
                :label="$t('Master Key')"
                :placeholder="$t('Enter Master Key')"
              />
            </b-col>
            <b-col md="6">
              <InputField
                id="etz-inward-tsq-client-secret"
                v-model="etzCredentialForm.inwardTSQClientSecret"
                :label="$t('TSQ Cypher')"
                :placeholder="$t('Enter TSQ Cypher')"
              />
            </b-col>

            <b-col md="6">
              <InputField
                id="etz-inward-sign-key"
                v-model="etzCredentialForm.inwardTSQEncKey"
                :label="$t('TSQ Enc. Key')"
                :placeholder="$t('Enter TSQ Enc. Key')"
              />
            </b-col>
            <b-col md="6">
              <InputField
                id="etz-terminal-id"
                v-model="etzCredentialForm.terminalId"
                :label="$t('Terminal ID')"
                :placeholder="$t('Enter Terminal ID')"
              />
            </b-col>
            <b-col
              cols="12"
              class="d-flex align-items-center justify-content-lg-end mt-1 mb-2"
            >
              <Button
                v-if="getUserPermission('ADD_ETZ_CREDENTIAL') && !hasETZCredential"
                :label="$t('Add ETZ Credentials')"
                :loading="isETZAddLoading"
                :disabled="isETZAddLoading || isETZUpdateLoading"
                size="md"
                class="mr-1"
                @click="handleETZCredentialSubmit"
              />
              <Button
                v-if="getUserPermission('UPDATE_ETZ_CREDENTIAL') && hasETZCredential"
                :label="$t('Update ETZ Credentials')"
                :loading="isETZUpdateLoading"
                :disabled="isETZUpdateLoading || isETZAddLoading"
                size="md"
                class="mt-1"
                @click="handleETZCredentialUpdate"
              />
            </b-col>
          </b-row>

        </b-form>
      </validation-observer>

      <FullScreenSpinner :show="showSpinner" />
    </div></b-card>

</template>

<script>
import {
  BCard, BRow, BCol,
  BForm, VBTooltip,
} from 'bootstrap-vue'
import { ValidationObserver } from 'vee-validate'
import { mapActions } from 'vuex'
import { modalMixins } from '@core/mixins/modal'
import { tableMixins } from '@core/mixins/table'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { permissionMixin } from '@core/mixins/permission'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import InputField from '../../../../forms/InputField.vue'
import InputPasswordField from '../../../../forms/InputPasswordField.vue'
import SelectField from '../../../../forms/SelectField.vue'
import { toDateWithYear } from '../../../../../helpers/formatDate'
import Button from '../../../../components/button/Button.vue'
import { eChannelsPermission } from '../../../../../helpers/permissions'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BForm,
    ValidationObserver,
    InputField,
    InputPasswordField,
    // InputNumberField,
    SelectField,
    FullScreenSpinner,
    Button,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  mixins: [modalMixins, tableMixins, sweetAlert, permissionMixin],
  data() {
    return {
      toDateWithYear,
      showSpinner: false,
      buttonLabel: '',
      isDisabled: false,
      isCustomDisabled: false,
      isLoading: false,
      isISWAddLoading: false,
      isISWUpdateLoading: false,
      isNIPAddLoading: false,
      isNIPUpdateLoading: false,
      isETZAddLoading: false,
      isETZUpdateLoading: false,
      hasISWCredential: false,
      isProvidusAddLoading: false,
      isProvidusUpdateLoading: false,
      hasProvidusCredential: false,
      isEditable: false,
      modalTitle: this.$t('Configure Gateway Credentials'),
      gatewayProviderOptions: [],

      transactionFormData: {
        gateway: '',
        feeBands: [],
        id: '',
      },
      iswCredentialForm: {
        id: '',
        clientID: '',
        clientSecret: '',
      },
      nipCredentialForm: {
        id: '',
        clientID: '',
        clientSecret: '',
        apiKey: '',
        appName: '',
      },
      etzCredentialForm: {
        id: '',
        clientID: '',
        clientSecret: '',
        inwardTSQClientSecret: '',
        salt: '',
        encKey: '',
        inwardTSQEncKey: '',
        terminalId: '',
        pin: '',
        pinEncKey: '',
      },
      providusCredentialForm: {
        id: '',
        userName: '',
        password: '',
      },
    }
  },
  computed: {
    isISWSelected() {
      const gw = this.transactionFormData.gateway
      if (!gw) return false
      if (typeof gw === 'string') return gw === 'ISW'
      const label = gw.label || gw.name || gw.code || gw.gateway
      return label === 'ISW'
    },
    isNIPSelected() {
      const gw = this.transactionFormData.gateway
      if (!gw) return false
      if (typeof gw === 'string') return gw === 'NIP'
      const label = gw.label || gw.name || gw.code || gw.gateway
      return label === 'NIP'
    },
    isETZSelected() {
      const gw = this.transactionFormData.gateway
      if (!gw) return false
      if (typeof gw === 'string') return gw === 'ETZ'
      const label = gw.label || gw.name || gw.code || gw.gateway
      return label === 'ETZ'
    },
    isProvidusSelected() {
      const gw = this.transactionFormData.gateway
      if (!gw) return false
      if (typeof gw === 'string') return gw === 'Providus'
      const label = gw.label || gw.name || gw.code || gw.gateway
      return label === 'Providus'
    },
  },
  watch: {

  },
  mounted() {
    this.fetchGatewayProviders()
    this.fetchISWCredential()
    this.fetchEtzCredential()
    this.fetchNIPCredential()
    this.fetchProvidusCredential()
  },
  methods: {
    ...mapActions({
      getFeeConfigurations: 'eChannels/getFeeConfigurations',
      getFeeConfigurationsByGateway: 'eChannels/getFeeConfigurationsByGateway',
      createFeeConfiguration: 'eChannels/createFeeConfiguration',
      updateFeeConfiguration: 'eChannels/updateFeeConfiguration',
      getGatewayProviders: 'eChannels/getGatewayProviders',
      getISWCredential: 'eChannels/getISWCredential',
      addISWCredential: 'eChannels/addISWCredential',
      updateISWCredential: 'eChannels/updateISWCredential',
      getNipEasyPayCredential: 'eChannels/getNipEasyPayCredential',
      addNipCredential: 'eChannels/addNipCredential',
      updateNipEasyPayCredential: 'eChannels/updateNipEasyPayCredential',
      getEtzCredential: 'eChannels/getEtzCredential',
      addEtzCredential: 'eChannels/addEtzCredential',
      updateEtzCredential: 'eChannels/updateEtzCredential',
      getProvidusEasyPayCredential: 'eChannels/getProvidusEasyPayCredential',
      addProvidusCredential: 'eChannels/addProvidusCredential',
      updateProvidusCredential: 'eChannels/updateProvidusCredential',
    }),

    handleSubmit() {
      this.$refs.gatewayConfigRules.validate().then(async success => {
        if (success) {
          const areYouSure = this.$t('Are you sure you want to')
          const thisText = this.$t('this Fee Configuration Setup?')
          this.confirm(this.gatewayConfigAction, { text: `${areYouSure} ${this.buttonLabel} ${thisText}` })
        }
      })
    },
    async handleISWCredentialSubmit() {
      if (!this.isISWSelected) return
      if (!this.iswCredentialForm.clientID || !this.iswCredentialForm.clientSecret) {
        this.alertError({ text: this.$t('Please provide both ISW Client ID and ISW Client Secret') })
        return
      }

      const areYouSure = this.$t('Are you sure you want to')
      const thisText = this.$t('these ISW credentials?')

      this.confirm(this.submitISWCredential, { text: `${areYouSure} ${this.$t('save')} ${thisText}` })
    },
    async submitISWCredential() {
      try {
        this.isISWAddLoading = true
        const formData = {
          clientID: this.iswCredentialForm.clientID,
          clientSecret: this.iswCredentialForm.clientSecret,
        }
        const response = await this.addISWCredential({
          formData,
          permission: eChannelsPermission.ADD_ISW_CREDENTIAL,
        })
        const { status } = await response
        if (status === 200) {
          const requestText = this.$t('Your request to')
          const successText = this.$t('ISW credentials was successful')
          this.alertSuccess({ text: `${requestText} ${this.$t('save')} ${successText}` })
          this.hasISWCredential = true
          await this.fetchISWCredential()
        }
      } catch (error) {
        if (error.response && error.response.data && error.response.data.errors) {
          error.response.data.errors.forEach(responseError => {
            const requestText = this.$t('Your request to')
            const reasonText = this.$t('save ISW credentials failed. Reason')
            const errorMessage = `${requestText} ${this.$t('save')} ${reasonText}: ${responseError.errorMessage}`
            this.alertError({ text: errorMessage })
          })
        } else {
          this.alertError({ text: error })
        }
      } finally {
        this.isISWAddLoading = false
      }
    },
    async handleProvidusCredentialSubmit() {
      if (!this.isProvidusSelected) return
      if (!this.providusCredentialForm.userName || !this.providusCredentialForm.password) {
        this.alertError({ text: this.$t('Please provide both Providus User Name and Providus Password') })
        return
      }

      const areYouSure = this.$t('Are you sure you want to')
      const thisText = this.$t('these Providus credentials?')

      this.confirm(this.submitProvidusCredential, { text: `${areYouSure} ${this.$t('save')} ${thisText}` })
    },
    async submitProvidusCredential() {
      try {
        this.isProvidusAddLoading = true
        const formData = {
          userName: this.providusCredentialForm.userName,
          password: this.providusCredentialForm.password,
        }
        const response = await this.addProvidusCredential({
          formData,
          permission: eChannelsPermission.ADD_PROVIDUS_CREDENTIAL,
        })
        const { status } = await response
        if (status === 200) {
          const requestText = this.$t('Your request to')
          const successText = this.$t('Providus credentials was successful')
          this.alertSuccess({ text: `${requestText} ${this.$t('save')} ${successText}` })
          this.hasProvidusCredential = true
          await this.fetchProvidusCredential()
        }
      } catch (error) {
        if (error.response && error.response.data && error.response.data.errors) {
          error.response.data.errors.forEach(responseError => {
            const requestText = this.$t('Your request to')
            const reasonText = this.$t('save Providus credentials failed. Reason')
            const errorMessage = `${requestText} ${this.$t('save')} ${reasonText}: ${responseError.errorMessage}`
            this.alertError({ text: errorMessage })
          })
        } else {
          this.alertError({ text: error })
        }
      } finally {
        this.isProvidusAddLoading = false
      }
    },

    async handleProvidusCredentialUpdate() {
      if (!this.isProvidusSelected) return
      if (!this.providusCredentialForm.id) {
        this.alertError({ text: this.$t('Providus Credential ID is required to update') })
        return
      }
      if (!this.providusCredentialForm.userName || !this.providusCredentialForm.password) {
        this.alertError({ text: this.$t('Please provide both Providus User Name and Providus Password') })
        return
      }

      const areYouSure = this.$t('Are you sure you want to')
      const thisText = this.$t('update these Providus credentials?')

      this.confirm(this.submitUpdateProvidusCredential, { text: `${areYouSure} ${thisText}` })
    },
    async submitUpdateProvidusCredential() {
      try {
        this.isProvidusUpdateLoading = true
        const formData = {
          id: this.providusCredentialForm.id,
          userName: this.providusCredentialForm.userName,
          password: this.providusCredentialForm.password,
        }
        const response = await this.updateProvidusCredential({
          formData,
          permission: eChannelsPermission.UPDATE_PROVIDUS_CREDENTIAL,
        })
        const { status } = await response
        if (status === 200) {
          const requestText = this.$t('Your request to')
          const successText = this.$t('update Providus credentials was successful')
          this.alertSuccess({ text: `${requestText}  ${successText}` })
        }
      } catch (error) {
        if (error.response && error.response.data && error.response.data.errors) {
          error.response.data.errors.forEach(responseError => {
            const requestText = this.$t('Your request to')
            const reasonText = this.$t('update Providus credentials failed. Reason')
            const errorMessage = `${requestText} ${reasonText}: ${responseError.errorMessage}`
            this.alertError({ text: errorMessage })
          })
        } else {
          this.alertError({ text: error })
        }
      } finally {
        this.isProvidusUpdateLoading = false
      }
    },

    handleETZCredentialSubmit(bvModalEvt) {
      if (bvModalEvt && typeof bvModalEvt.preventDefault === 'function') {
        bvModalEvt.preventDefault()
      }
      this.$refs.etzGatewayConfigRules.validate().then(async success => {
        if (success) {
          const areYouSure = this.$t('Are you sure you want to')
          const thisText = this.$t('these ETZ credentials?')
          this.confirm(this.submitETZCredential, { text: `${areYouSure} ${this.$t('save')} ${thisText}` })
        }
      })
      const areYouSure = this.$t('Are you sure you want to')
      const thisText = this.$t('these ETZ credentials?')

      this.confirm(this.submitETZCredential, { text: `${areYouSure} ${this.$t('save')} ${thisText}` })
    },
    async submitETZCredential() {
      try {
        this.isETZAddLoading = true
        const formData = { ...this.etzCredentialForm }
        const response = await this.addEtzCredential({
          formData,
          permission: eChannelsPermission.ADD_ETZ_CREDENTIAL,
        })
        const { status } = await response
        if (status === 200) {
          const requestText = this.$t('Your request to')
          const successText = this.$t('ETZ credentials was successful')
          this.alertSuccess({ text: `${requestText} ${this.$t('save')} ${successText}` })
          this.hasETZCredential = true
          await this.fetchEtzCredential()
        }
      } catch (error) {
        if (error.response && error.response.data && error.response.data.errors) {
          error.response.data.errors.forEach(responseError => {
            const requestText = this.$t('Your request to')
            const reasonText = this.$t('save ETZ credentials failed. Reason')
            const errorMessage = `${requestText} ${this.$t('save')} ${reasonText}: ${responseError.errorMessage}`
            this.alertError({ text: errorMessage })
          })
        } else {
          this.alertError({ text: error })
        }
      } finally {
        this.isETZAddLoading = false
      }
    },
    async handleETZCredentialUpdate(bvModalEvt) {
      if (bvModalEvt && typeof bvModalEvt.preventDefault === 'function') {
        bvModalEvt.preventDefault()
      }
      this.$refs.etzGatewayConfigRules.validate().then(async success => {
        if (success) {
          const areYouSure = this.$t('Are you sure you want to')
          const thisText = this.$t('these ETZ credentials?')
          this.confirm(this.submitUpdateETZCredential, { text: `${areYouSure} ${this.$t('save')} ${thisText}` })
        }
      })
    },
    async submitUpdateETZCredential() {
      try {
        this.isETZUpdateLoading = true
        const formData = { ...this.etzCredentialForm }
        const response = await this.updateEtzCredential({
          formData,
          permission: eChannelsPermission.UPDATE_ETZ_CREDENTIAL,
        })
        const { status } = await response
        if (status === 200) {
          const requestText = this.$t('Your request to')
          const successText = this.$t('update ETZ credentials was successful')
          this.alertSuccess({ text: `${requestText} ${successText}` })
        }
      } catch (error) {
        if (error.response && error.response.data && error.response.data.errors) {
          error.response.data.errors.forEach(responseError => {
            const requestText = this.$t('Your request to')
            const reasonText = this.$t('update ETZ credentials failed. Reason')
            const errorMessage = `${requestText} ${reasonText}: ${responseError.errorMessage}`
            this.alertError({ text: errorMessage })
          })
        } else {
          this.alertError({ text: error })
        }
      } finally {
        this.isETZUpdateLoading = false
      }
    },
    async handleISWCredentialUpdate() {
      if (!this.isISWSelected) return
      if (!this.iswCredentialForm.id) {
        this.alertError({ text: this.$t('ISW Credential ID is required to update') })
        return
      }
      if (!this.iswCredentialForm.clientID || !this.iswCredentialForm.clientSecret) {
        this.alertError({ text: this.$t('Please provide both ISW Client ID and ISW Client Secret') })
        return
      }

      const areYouSure = this.$t('Are you sure you want to')
      const thisText = this.$t('update these ISW credentials?')

      this.confirm(this.submitUpdateISWCredential, { text: `${areYouSure} ${thisText}` })
    },
    async submitUpdateISWCredential() {
      try {
        this.isISWUpdateLoading = true
        const formData = {
          id: this.iswCredentialForm.id,
          clientID: this.iswCredentialForm.clientID,
          clientSecret: this.iswCredentialForm.clientSecret,
        }
        const response = await this.updateISWCredential({
          formData,
          permission: eChannelsPermission.UPDATE_ISW_CREDENTIAL,
        })
        const { status } = await response
        if (status === 200) {
          const requestText = this.$t('Your request to')
          const successText = this.$t('update ISW credentials was successful')
          this.alertSuccess({ text: `${requestText} ${successText}` })
        }
      } catch (error) {
        if (error.response && error.response.data && error.response.data.errors) {
          error.response.data.errors.forEach(responseError => {
            const requestText = this.$t('Your request to')
            const reasonText = this.$t('update ISW credentials failed. Reason')
            const errorMessage = `${requestText} ${reasonText}: ${responseError.errorMessage}`
            this.alertError({ text: errorMessage })
          })
        } else {
          this.alertError({ text: error })
        }
      } finally {
        this.isISWUpdateLoading = false
      }
    },
    async fetchGatewayProviders() {
      try {
        const response = await this.getGatewayProviders({ permission: eChannelsPermission.CONFIGURE_TRANSFER_FEE })
        const { status, data } = await response
        if (status === 200 && data !== null && Object.keys(data).length) {
          this.gatewayProviderOptions = data
        }
      } catch (error) {
        this.alertError({ text: error })
      }
    },
    async fetchISWCredential() {
      try {
        const response = await this.getISWCredential({ permission: eChannelsPermission.VIEW_TRANSFER_GATEWAY_CREDENTIAL })
        const { status, data } = await response
        if (status === 200 && data !== null && Object.keys(data).length) {
          const {
            id,
            clientID,
            clientSecret,
          } = data

          this.iswCredentialForm.id = id || ''
          this.iswCredentialForm.clientID = clientID || ''
          this.iswCredentialForm.clientSecret = clientSecret || ''
          this.hasISWCredential = !!id && !!clientID && !!clientSecret
        } else {
          this.hasISWCredential = false
        }
      } catch (error) {
        this.alertError({ text: error })
        this.hasISWCredential = false
      }
    },
    async fetchEtzCredential() {
      try {
        const response = await this.getEtzCredential({ permission: eChannelsPermission.VIEW_TRANSFER_GATEWAY_CREDENTIAL })
        const { status, data } = await response
        if (status === 200 && data !== null && Object.keys(data).length) {
          const {
            id,
            clientID,
            clientSecret,
            inwardTSQClientSecret,
            salt,
            encKey,
            inwardTSQEncKey,
            terminalId,
            pin,
            pinEncKey,
          } = data

          this.etzCredentialForm.id = id || ''
          this.etzCredentialForm.clientID = clientID || ''
          this.etzCredentialForm.clientSecret = clientSecret || ''
          this.etzCredentialForm.inwardTSQClientSecret = inwardTSQClientSecret || ''
          this.etzCredentialForm.salt = salt || ''
          this.etzCredentialForm.encKey = encKey || ''
          this.etzCredentialForm.inwardTSQEncKey = inwardTSQEncKey || ''
          this.etzCredentialForm.terminalId = terminalId || ''
          this.etzCredentialForm.pin = pin || ''
          this.etzCredentialForm.pinEncKey = pinEncKey || ''
          this.hasETZCredential = !!id && !!clientID && !!clientSecret
        } else {
          this.hasETZCredential = false
        }
      } catch (error) {
        this.alertError({ text: error })
        this.hasETZCredential = false
      }
    },
    async fetchNIPCredential() {
      try {
        const response = await this.getNipEasyPayCredential({ permission: eChannelsPermission.VIEW_TRANSFER_GATEWAY_CREDENTIAL })
        const { status, data } = response
        if (status === 200 && data !== null && Object.keys(data).length) {
          const {
            id,
            clientID,
            clientSecret,
            apiKey,
            appName,
          } = data
          this.nipCredentialForm.id = id || ''
          this.nipCredentialForm.clientID = clientID || ''
          this.nipCredentialForm.clientSecret = clientSecret || ''
          this.nipCredentialForm.apiKey = apiKey || ''
          this.nipCredentialForm.appName = appName || ''
          this.hasNIPCredential = !!id && !!clientID && !!clientSecret
        } else {
          this.hasNIPCredential = false
        }
      } catch (error) {
        this.alertError({ text: error })
        this.hasNIPCredential = false
      }
    },
    async fetchProvidusCredential() {
      try {
        const response = await this.getProvidusEasyPayCredential({ permission: eChannelsPermission.VIEW_TRANSFER_GATEWAY_CREDENTIAL })
        const { status, data } = response
        if (status === 200 && data !== null && Object.keys(data).length) {
          const {
            id,
            userName,
            password,
          } = data
          this.providusCredentialForm.id = id || ''
          this.providusCredentialForm.userName = userName || ''
          this.providusCredentialForm.password = password || ''
          this.hasProvidusCredential = !!id && !!userName && !!password
        } else {
          this.hasProvidusCredential = false
        }
      } catch (error) {
        this.alertError({ text: error })
        this.hasProvidusCredential = false
      }
    },
    async handleNIPCredentialSubmit() {
      if (!this.isNIPSelected) return
      const {
        clientID, clientSecret, apiKey, appName,
      } = this.nipCredentialForm
      if (!clientID || !clientSecret || !apiKey || !appName) {
        this.alertError({ text: this.$t('Please provide all NIP credential fields') })
        return
      }

      const areYouSure = this.$t('Are you sure you want to')
      const thisText = this.$t('these NIP credentials?')

      this.confirm(this.submitNIPCredential, { text: `${areYouSure} ${this.$t('save')} ${thisText}` })
    },
    async submitNIPCredential() {
      try {
        this.isNIPAddLoading = true
        const formData = {
          clientID: this.nipCredentialForm.clientID,
          clientSecret: this.nipCredentialForm.clientSecret,
          apiKey: this.nipCredentialForm.apiKey,
          appName: this.nipCredentialForm.appName,
        }
        const response = await this.addNipCredential({
          formData,
          permission: eChannelsPermission.ADD_NIP_CREDENTIAL,
        })
        const { status } = response
        if (status === 200) {
          const requestText = this.$t('Your request to')
          const successText = this.$t('NIP credentials was successful')
          this.alertSuccess({ text: `${requestText} ${this.$t('save')} ${successText}` })
          this.hasNIPCredential = true
          await this.fetchNIPCredential()
        }
      } catch (error) {
        if (error.response && error.response.data && error.response.data.errors) {
          error.response.data.errors.forEach(responseError => {
            const requestText = this.$t('Your request to')
            const reasonText = this.$t('save NIP credentials failed. Reason')
            const errorMessage = `${requestText} ${this.$t('save')} ${reasonText}: ${responseError.errorMessage}`
            this.alertError({ text: errorMessage })
          })
        } else {
          this.alertError({ text: error })
        }
      } finally {
        this.isNIPAddLoading = false
      }
    },
    handleNIPCredentialUpdate() {
      if (!this.isNIPSelected) return
      if (!this.nipCredentialForm.id) {
        this.alertError({ text: this.$t('NIP Credential ID is required to update') })
        return
      }
      const {
        clientID, clientSecret, apiKey, appName,
      } = this.nipCredentialForm
      if (!clientID || !clientSecret || !apiKey || !appName) {
        this.alertError({ text: this.$t('Please provide all NIP credential fields') })
        return
      }

      const areYouSure = this.$t('Are you sure you want to')
      const thisText = this.$t('update these NIP credentials?')

      this.confirm(this.submitUpdateNIPCredential, { text: `${areYouSure} ${thisText}` })
    },
    async submitUpdateNIPCredential() {
      try {
        this.isNIPUpdateLoading = true
        const formData = {
          id: this.nipCredentialForm.id,
          clientID: this.nipCredentialForm.clientID,
          clientSecret: this.nipCredentialForm.clientSecret,
          apiKey: this.nipCredentialForm.apiKey,
          appName: this.nipCredentialForm.appName,
        }
        const response = await this.updateNipEasyPayCredential({
          formData,
          permission: eChannelsPermission.UPDATE_NIP_CREDENTIAL,
        })
        const { status } = await response
        if (status === 200) {
          const requestText = this.$t('Your request to')
          const successText = this.$t('update NIP credentials was successful')
          this.alertSuccess({ text: `${requestText} ${successText}` })
        }
      } catch (error) {
        if (error.response && error.response.data && error.response.data.errors) {
          error.response.data.errors.forEach(responseError => {
            const requestText = this.$t('Your request to')
            const reasonText = this.$t('update NIP credentials failed. Reason')
            const errorMessage = `${requestText} ${reasonText}: ${responseError.errorMessage}`
            this.alertError({ text: errorMessage })
          })
        } else {
          this.alertError({ text: error })
        }
      } finally {
        this.isNIPUpdateLoading = false
      }
    },
  },
}
</script>
